import * as types from "../actions/types/airtime.types";

const initialState = {
  billerData: {
    billerCode: null,
    billerName: "",
  },
  airTimeState: "idle",
  errorAirtimeModal: false,
  successAirtimeModal: false,
  initiateAirtimeState: "idle",
  initiateAirtimeData: {},
};

export const airtimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AIRTIME_PURCHASE_STARTED:
      return {
        ...state,
        airTimeState: "loading",
        errorAirtimeModal: false,
      };
    case types.AIRTIME_PURCHASE_SUCCEEDED:
      return {
        ...state,
        airTimeState: "success",
        errorAirtimeModal: false,
        successModal: true,
      };
    case types.AIRTIME_PURCHASE_FAILED:
      return {
        ...state,
        errorMessage: action.payload.message,
        airTimeState: "failed",
        errorAirtimeModal: true,
      };
    case types.SET_AIRTIME_BILLER:
      return {
        ...state,
        billerData: {
          ...state.billerData,
          billerCode: action.payload.billerCode,
          billerName: action.payload.billerName,
          billerIcon: action.payload.billerIcon
        },
      };
    case types.INITIATE_AIRTIME_TRANSFER_STARTED:
      return {
        ...state,
        initiateAirtimeState: "loading",
      };
    case types.INITIATE_AIRTIME_TRANSFER_SUCCEDEED:
      return {
        ...state,
        initiateAirtimeState: "success",
        initiateAirtimeData: action.payload,
      };
    case types.INITIATE_AIRTIME_TRANSFER_FAILED:
      return {
        ...state,
        initiateAirtimeState: "failed",
      };
    default:
      return state;
  }
};
